import { render, staticRenderFns } from "./menulateral.vue?vue&type=template&id=d6bc4706&scoped=true&"
import script from "./menulateral.vue?vue&type=script&lang=js&"
export * from "./menulateral.vue?vue&type=script&lang=js&"
import style0 from "./menulateral.vue?vue&type=style&index=0&id=d6bc4706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bc4706",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/ALIO/APP/APPVentas/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListGroup } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileSubTitle } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTreeview } from 'vuetify/lib'
installComponents(component, {VCheckbox,VContainer,VFlex,VList,VListGroup,VListTile,VListTileAction,VListTileContent,VListTileSubTitle,VListTileTitle,VTextField,VTreeview})
